import { render, staticRenderFns } from "./BasicSiteDetails.vue?vue&type=template&id=368e06f7&"
import script from "./BasicSiteDetails.vue?vue&type=script&lang=js&"
export * from "./BasicSiteDetails.vue?vue&type=script&lang=js&"
import style0 from "./BasicSiteDetails.vue?vue&type=style&index=0&id=368e06f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports